<template>
    <div>
        <div class="modal fade" id="accountModal" tabindex="-1" role="dialog" aria-labelledby="accountModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="accountModalLabel">User Account</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">


                        <div class="d-flex align-items-center">
                            <div v-if="model.currentUser && model.currentUser.image" style="width: 34px; height: 34px;"
                                 class="d-flex align-items-center rounded-circle bg-dark text-white">
                                <img :src="model.currentUser.image" class="rounded-circle"
                                     style="width: 34px; height: 34px;">
                            </div>

                            <div v-else-if="model.currentUser && model.currentUser.name"
                                 style="width: 34px; height: 34px;"
                                 class="d-flex align-items-center rounded-circle bg-dark text-white">
                                <div class="w-100 text-center text-uppercase">
                                    {{model.currentUser.name.substring(0,1)}}
                                </div>
                            </div>

                            <div class="mx-2">
                                {{model.currentUser.name}}
                            </div>
                        </div>

                        <div class="card my-3">
                            <div class="card-body">
                                <p class="card-text">
                                    Affiliate link: <a href="javascript:void(0)" @click="onCopyClick">Copy to clipboard <i
                                        class="far fa-copy"></i></a>
                                    <span v-if="linkCopied" class="text-muted font-weight-bold text-sm">copied!</span>
                                </p>
                                <a :href="model.currentUser.twitter_link" target="_blank" class="btn btn-primary">Share on twitter <i class="fab fa-twitter"></i> </a>
                            </div>
                        </div>

                        <div v-if="isAdmin" class="card my-3">
                            <div v-if="model.currentUser.push_enabled" class="card-body">
                                <h5 class="card-title">Desktop Notifications Enabled</h5>
                                <button class="btn btn-primary" @click="sendDesktopNotification">Send Test Notification</button>
                            </div>
                            <div v-else class="card-body">
                                <h5 class="card-title">Desktop Notifications</h5>
                                <button class="btn btn-primary" @click="enableDesktopNotifications">Enable Notifications</button>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import UserService from "../services/UserService";
    import DesktopNotificationsService from "../services/DesktopNotificationsService";

    export default {
        name: 'AccountModal',
        props: {
            yesEvent: Function
        },
        computed: {
            isAdmin() {
                return webase.utils.user.isAdmin()
            }
        },
        data() {
            return {
                model: webase.model,
                linkCopied: false,
                referralVisits: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('accountModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()

            let service = new UserService()
            service.referrals().then( (visitsByMonth) => {
                this.referralVisits = visitsByMonth
            })
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            onCopyClick() {
                let url = 'https://www.webase.com/a/' + this.model.currentUser.referral_code

                navigator.clipboard.writeText(url).then(() => {
                    console.log('Affiliate URL copied to clipboard');
                    this.linkCopied = true
                }, function (err) {
                    console.log('Affiliate URL *NOT* copied to clipboard');
                });
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            enableDesktopNotifications() {
                let service = new DesktopNotificationsService()
                service.enableNotifications()
            },
            sendDesktopNotification() {
                let service = new DesktopNotificationsService()
                service.sendTestNotification()
            }
        }
    }
</script>
